import { useMemo } from 'react';
import cx from 'classnames';
import { Box } from '@material-ui/core';

import PricePerUnit from 'components/PricePerUnit';

import style from './style.module.scss';

const getCurrencyParts = (price) => {
  const int = Math.trunc(price)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  const d =
    +Number(
      (parseFloat(price.toFixed(2)) - Math.trunc(price)).toFixed(2) * 100,
    ).toFixed() || '00';

  const dec = `0${d}`.slice(-2);

  return [int, dec];
};

const Price = (props) => {
  const {
    perUnit,
    currency,
    size = 'medium',
    amount: initialAmount,
    className,
    ...rest
  } = props;

  const amount = useMemo(() => initialAmount / 100, [initialAmount]);

  const [integer, residue] = useMemo(() => {
    return getCurrencyParts(amount);
  }, [amount]);

  // TODO: Take a look do we need that
  // const perUnitFormatted = useMemo(() => {
  //   if (!perUnit) {
  //     return perUnit;
  //   }
  //   return getCurrencyParts(perUnit).join(',');
  // }, [perUnit]);

  const valid = useMemo(() => {
    return Number.isFinite(amount);
  }, [amount]);

  return (
    <Box className={cx(style.root, className)} {...rest}>
      <div className={style.main}>
        <div className={cx(style.price, style[size])}>
          {valid && (
            <>
              <sup>$</sup>
              {integer}
              <sup>{residue}</sup>
            </>
          )}
        </div>

        {currency && <div className={style.currency}>{currency}</div>}
      </div>

      {perUnit && <PricePerUnit amount={perUnit} />}
    </Box>
  );
};

export default Price;
